<template>
  <div>
    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Register Institution</h5>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="dataForm" #default="{ invalid }">
          <b-form ref="form" @submit.stop.prevent="handleCreate">
            <b-row>
                <b-col cols="12" md="5">
                  <b-row>
                    <b-col cols="12" md="8" class="mb-md-0 mb-2">
                      <b-form-group label-for="name" label="Name" label-class="mb-1 font-weight-bold">
                        <validation-provider #default="{ errors }" name="name" rules="">
                          <b-form-input
                            id="name"
                            name="name"
                            size="sm"
                            placeholder="Name"
                            v-model="institute.name"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                          <small class="text-danger" v-if="serverErrors && serverErrors.name">{{ serverErrors.name[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="4" class="mb-md-0 mb-2">
                      <b-form-group label-for="abbreviation" label="Abbreviation" label-class="mb-1 font-weight-bold">
                        <validation-provider #default="{ errors }" name="abbreviation" rules="">
                          <b-form-input
                            id="abbreviation"
                            name="abbreviation"
                            size="sm"
                            placeholder="Abbreviation"
                            v-model="institute.abbreviation"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                          <small class="text-danger" v-if="serverErrors && serverErrors.abbreviation">{{ serverErrors.abbreviation[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" md="12">
                      <fieldset>
                        <legend style="font-size: 12px;">Benefits <small class="text-danger" v-if="serverErrors && serverErrors.benefits">{{ serverErrors.benefits[0] }}</small></legend>
                        <div style="position: relative;width: 100%;height:24vh;border: 1px solid #eee;border-radius: 3px;">
                          <!-- Levy List -->
                          <b-table
                            striped
                            small
                            ref="records"
                            class="position-relative"
                            :items="levies"
                            responsive
                            :fields="[{ key: 'id', label: ''}]"
                            primary-key="id"
                            :sort-by.sync="sortBy"
                            show-empty
                            empty-text="No records found"
                            :sort-desc.sync="isSortDirDesc"
                            sticky-header="24vh"
                          >
                            <template #cell(id)="data">
                              <b-form-checkbox
                                v-model="institute.benefits"
                                :value="data.item.id"
                                class="custom-control-warning"
                              >
                                {{ data.item.name }}
                              </b-form-checkbox>
                            </template>
                          </b-table>
                        </div>
                      </fieldset>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="6" class="mb-md-0 mb-2 pt-2">
                      <b-button
                          size="sm"
                          variant="primary"
                          @click="submit()"
                          :disabled="saving"
                      >
                          <b-spinner small class="mr-1" label="Small Spinner" v-if="saving" />
                          <span v-if="!saving">Save</span>
                          <span v-if="saving">Saving...</span>
                      </b-button>
                  </b-col>

                  <b-col cols="6" class="mb-md-0 mb-2 pt-2 d-flex justify-content-end">
                      <b-button
                          size="sm"
                          @click="clear()"
                          variant="outline-secondary"
                      >
                          Clear
                      </b-button>
                  </b-col> 
                  </b-row>
                </b-col>

                <b-col cols="12" md="7">
                  <b-row>
                    <b-col cols="12" md="12">
                      <b-form-group label-for="payControl" label="">
                        <validation-provider #default="{ errors }" name="payControl" rules="">
                          <b-form-checkbox
                            v-model="institute.payControl"
                            :value="true"
                            class="custom-control-info"
                            :checked="institute.payControl"
                          >
                            <span style="font-size:11px;cursor: pointer;">Pay Control Number</span>
                          </b-form-checkbox>
                          <small class="text-danger" v-if="serverErrors && serverErrors.payControl">{{ serverErrors.payControl[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!institute.payControl">
                    <b-col cols="12" md="5">
                      <b-form-group label-for="bank_id" label="Bank Account">
                          <validation-provider #default="{ errors }" name="bank_id" rules="">
                              <b-form-select
                                  id="bank_id"
                                  name="bank_id"
                                  size="sm"
                                  v-model="institute.bank_id"
                                  @change="changeBank()"
                              >
                                  <b-form-select-option :value="null">Select...</b-form-select-option>
                                  <b-form-select-option v-for="bank in banks" :key="bank.id" :value="bank.id">
                                      {{ bank.name }}
                                  </b-form-select-option>
                              </b-form-select>
                              <small class="text-danger">{{ errors[0] }}</small>
                              <small class="text-danger" v-if="serverErrors && serverErrors.bank_id">{{ serverErrors.bank_id[0] }}</small>
                          </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="7">
                      <b-form-group label-for="branch_id" label="Bank Branch">
                        <validation-provider #default="{ errors }" name="branch_id" rules="">
                          <b-form-select
                            id="branch_id"
                            name="branch_id"
                            v-model="institute.branch_id"
                            size="sm"
                          >
                            <b-form-select-option :value="null">Select...</b-form-select-option>
                            <b-form-select-option v-for="branch in branches" :key="branch.id" :value="branch.id">
                              {{ branch.name }}
                            </b-form-select-option>
                          </b-form-select>
                          <small class="text-danger">{{ errors[0] }}</small>
                          <small class="text-danger" v-if="serverErrors && serverErrors.branch_id">{{ serverErrors.branch_id[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!institute.payControl">
                    <b-col cols="12" md="5">
                      <b-form-group label-for="account_number" label="Account Number">
                        <validation-provider #default="{ errors }" name="account_number" rules="">
                          <b-form-input
                            id="account_number"
                            name="account_number"
                            v-model="institute.account_number"
                            :state="errors.length > 0 ? false : null"
                            size="sm"
                            placeholder="Account Number"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                          <small class="text-danger" v-if="serverErrors && serverErrors.account_number">{{ serverErrors.account_number[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="5">
                      <b-form-group label-for="account_name" label="Account Name">
                        <validation-provider #default="{ errors }" name="account_name" rules="">
                          <b-form-input
                            id="account_name"
                            name="account_name"
                            v-model="institute.account_name"
                            :state="errors.length > 0 ? false : null"
                            size="sm"
                            placeholder="Account Name"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                          <small class="text-danger" v-if="serverErrors && serverErrors.account_name">{{ serverErrors.account_name[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="2">
                      <b-form-group label-for="currency_id" label="Currency">
                        <validation-provider #default="{ errors }" name="currency_id" rules="">
                          <b-form-select
                            id="currency_id"
                            name="currency_id"
                            v-model="institute.currency_id"
                            size="sm"
                          >
                            <b-form-select-option :value="null">Select...</b-form-select-option>
                            <b-form-select-option v-for="currency in currencies" :key="currency.id" :value="currency.id">
                              {{ currency.abbreviation }}
                            </b-form-select-option>
                          </b-form-select>
                          <small class="text-danger">{{ errors[0] }}</small>
                          <small class="text-danger" v-if="serverErrors && serverErrors.currency_id">{{ serverErrors.currency_id[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" md="12">
                      <p style="font-size:11px;font-weight:bold;">Operating Areas</p>
                      <span>
                        <small class="text-danger" v-if="serverErrors && serverErrors.locations">{{ serverErrors.locations[0] }}</small>
                      </span>
                      <hr />
                      <template>
                        <app-timeline>
                          <!-- Administrative Locations In Operations -->
                          <app-timeline-item
                            variant="info"
                            icon="MapPinIcon"
                            v-for="location in administrativeLocations"
                            :key="location.id"
                          >
                            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                              <h6>
                                <b-form-checkbox
                                  v-model="institute.locations"
                                  :value="location.id"
                                  class="custom-control-info"
                                >
                                  {{ location.name }} {{ location.level.name }}
                                </b-form-checkbox>
                              </h6>
                            </div>
                            <template v-if="location.children.length > 0 && institute.locations.includes(location.id)">
                              <div
                                class="d-flex flex-sm-row flex-column justify-content-between align-items-start"
                                style="overflow-x: auto;"
                              >
                                <b-form-checkbox
                                  v-for="child in location.children"
                                  :key="child.id"
                                  v-model="institute.locations"
                                  :value="child.id"
                                  class="custom-control-info"
                                >
                                  {{ child.name }} {{ child.level.name }}
                                </b-form-checkbox>
                              </div>
                            </template>
                          </app-timeline-item>
                        </app-timeline>
                      </template>
                    </b-col>
                  </b-row>

                  <!-- <b-row>
                    <b-col cols="12">
                      <pre>{{ institute }}</pre>
                    </b-col>
                  </b-row> -->
                </b-col>
            </b-row>
            
          </b-form>
        </validation-observer>
      </b-card-body>
      <!-- {{ institute }} -->
    </b-card>
    <!-- ./Filters -->

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search & Button -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
                size="sm"
              />
            </div>
          </b-col>
          <!-- ./Search & Button-->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        striped
        hover
        small
        ref="records"
        class="position-relative"
        :items="fetch"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(name)="data">
          {{ data.item.name.toUpperCase() }}
        </template>

        <template #cell(abbreviation)="data">
          <span v-if="data.item.abbreviation != null">{{ data.item.abbreviation.toUpperCase() }}</span>
        </template>
        
        <template #cell(account)="data">
          <span v-if="!data.item.payControl">{{ data.item.account.number }} {{ data.item.account.currency.abbreviation }} : {{ data.item.account.bank.abbreviation }}/{{ data.item.account.branch.name }}</span>
          <span v-else>CONTROL NUMBER</span>
        </template>

        <template #cell(benefits)="data">
          <div class="demo-inline-spacing">
            <b-badge variant="light-warning" v-for="benefit in data.item.benefits" :key="benefit.id">
              <feather-icon
                icon="DollarSignIcon"
                class="mr-25"
              />
              <span v-if="benefit.levy.isPercentage === 1">{{ benefit.levy.value }}% {{ benefit.levy.name }}</span>
              <span v-else>{{ benefit.levy.value }} {{ benefit.levy.name }}</span>
            </b-badge>
          </div>
        </template>

        <template #cell(locations)="data">
            <div id="component-breadcrumbs">
                <b-breadcrumb
                    class="breadcrumb-pipes"
                    :items="data.item.locations.map(e => ({ text: e.name, active: false }))"
                />
            </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item :to="{ path: 'institutions/' + data.item.id }" @click="storeItem(data.item)">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item @click="invokeUpdateForm(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="remove(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ from }} to {{ to }} of
              {{ totalRecords }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BPagination,
  BForm,
  BFormGroup,
  BButton,
  BFormSelect,
  BFormSelectOption,
  BFormInput,
  BFormCheckbox ,
  BDropdown,
  BDropdownItem,
  BSpinner,
  BBreadcrumb,
  BBadge,
  BImg, BAvatar, BMedia, BCollapse, VBToggle, BListGroup, BListGroupItem, BAvatarGroup, VBTooltip,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import payableinstitutesStoreModule from '@/views/cromis/payableinstitutes/payableinstitutesStoreModule'
import usepayableinstitutesList from '@/views/cromis/payableinstitutes/usePayableInstitutesList'
import LocationSelect from '@/views/cromis/payableinstitutes/LocationSelect.vue'

export default {
  props: {},
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BPagination,
    BForm,
    BFormGroup,
    BButton,
    BFormSelect,
    BFormSelectOption,
    BFormInput,
    BFormCheckbox ,
    vSelect,
    BDropdown,
    BDropdownItem,
    BSpinner,
    BBreadcrumb,
    BBadge,
    ValidationObserver,
    ValidationProvider,
    LocationSelect,

    AppTimeline,
    AppTimelineItem,
    BImg,
    BMedia,
    BAvatar,
    BButton,
    BCollapse,
    BListGroup,
    BListGroupItem,
    BAvatarGroup,
    BBadge,
  },
  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },

  setup(props, context) {
    const serverErrors = ref(null)
    const saving = ref(false)
    const dataForm = ref(null)
    const locations = ref([])
    const levies = ref([])
    const currencies = ref([])
    const banks = ref([])
    const branches = ref([])

    const administrativeLocations = ref(JSON.parse(localStorage.getItem('userData')).client.country.locations)

    const institute = ref({
      id: null,
      name: null,
      abbreviation: null,
      payControl: false,
      bank_id: null,
      branch_id: null,
      account_number: null,
      account_name: null,
      currency_id: null,
      benefits: [],
      locations: [],
    });

    const CROMIS_STORE_MODULE_NAME = "cromis-institute";

    // Register module
    if (!store.hasModule(CROMIS_STORE_MODULE_NAME))
      store.registerModule(
        CROMIS_STORE_MODULE_NAME,
        payableinstitutesStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CROMIS_STORE_MODULE_NAME))
        store.unregisterModule(CROMIS_STORE_MODULE_NAME);
    })

    onMounted(async () => {
        await store.dispatch('cromis-institute/levies', { pay_society: 0 })
            .then(response => {
                levies.value = response.data.levies
            })
            .catch(error => {
                console.log(error)
            })

        await store.dispatch('cromis-institute/currencies')
            .then(response => {
                currencies.value = response.data.currencies
            })
            .catch(error => {
                console.log(error)
            })

        await store.dispatch('cromis-institute/banks')
            .then(response => {
                banks.value = response.data.banks
            })
            .catch(error => {
                console.log(error)
            })
    })

    const {
      fetch,
      columns,
      perPage,
      currentPage,
      totalRecords,
      from,
      to,
      meta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      records,
      refetch,
    } = usepayableinstitutesList();

    const clear = () => {
      institute.value = {
        id: null,
        name: null,
        abbreviation: null,
        payControl: false,
        bank_id: null,
        branch_id: null,
        account_number: null,
        account_name: null,
        currency_id: null,
        benefits: [],
        locations: [],
      }
    }

    const changeBank = async () => {
        institute.value.branch_id = null

        if(institute.value.bank_id == null){
          branches.value = []
        }
        else {
          branches.value = banks.value.filter(bank => bank.id === institute.value.bank_id)[0].branches
        }
    }

    const storeItem = (item) => {
      localStorage.setItem('selectedInstitution', JSON.stringify(item));
    }

    const invokeUpdateForm = (item) => {
      institute.value = {
        id: item.id,
        name: item.name,
        abbreviation: item.abbreviation,
        payControl: item.payControl,
        bank_id: item.account === null? null : item.account.bank.id,
        branch_id: item.account === null? null : item.account.branch.id,
        account_number: item.account === null? null : item.account.number,
        account_name: item.account === null? null : item.account.name,
        currency_id: item.account === null? null : item.account.currency.id,
        benefits: item.benefits.map(e => e.levy.id),
        locations: [],
      }

      branches.value = banks.value.filter(bank => bank.id === institute.value.bank_id)[0].branches

      let markedLocations = []
      for(let i = 0; i < item.locations.length; i++){
        markedLocations.push(item.locations[i].id)
        parent = item.locations[i].parent
        while(parent !== null){
          if(!markedLocations.includes(parent.id))
            markedLocations.push(parent.id)

          parent = parent.parent
        }
      }

      markedLocations.sort((a, b) => a - b)

      institute.value.locations = markedLocations
    }

    const isFormValid = async () => {
      let isValid = false
      await dataForm.value.validate().then((success) => {
        isValid = success
      });

      return isValid
    }

    const submit = (bvModalEvt) => {
      serverErrors.value = null;
      // Handle form submit
      const valid = isFormValid()

      if (!valid) {
        saving.value = false
        return
      }

      if (institute.value.id === null || institute.value.id === 0)
        handleCreate();
      else
        handleUpdate(institute.value);
    }

  const handleCreate = async () => {
    saving.value = true

    await store.dispatch('cromis-institute/create', institute.value)
              .then(response => {
                refetch()
                saving.value = false

                clear()
                context.root.$swal({
                  icon: 'success',
                  text: `Institute was registered successfully!`,
                  showConfirmButton: true,
                  timer: 3000,
                  customClass: { confirmButton: 'btn btn-primary' },
                  buttonsStyling: false,
                })
              }).catch(error => {
                saving.value = false

                // show validation errors if any
                if (error.response?.status === 422) {
                  serverErrors.value = error.response.data.errors
                }
                else{
                  context.root.$swal({
                    icon: 'error',
                    title: 'Server Error',
                    text: error.response?.data?.message || 'Something went wrong. See tech support',

                    showConfirmButton: true,
                    customClass: { confirmButton: 'btn btn-danger' },
                    buttonsStyling: false,
                  })
                }
              })
  }


  const handleUpdate = async (item) => {
    saving.value = true;

    await store.dispatch("cromis-institute/update", { id: item.id, data: item })
        .then((response) => {
          refetch()
          saving.value = false;

          clear()
          context.root.$swal({
            icon: "success",
            text: `Changes to institute ${response.data.name} has been saved successfully!`,
            showConfirmButton: true,
            timer: 3000,
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          })
        })
        .catch((error) => {
          saving.value = false

          if (error.response.status === 422) {
            serverErrors.value = error.response.data.errors
          }
          else {
            context.root.$swal({
              icon: "error",
              title: "Server Error",
              text: "Something went wrong. See tech support",
              showConfirmButton: true,
              customClass: {
                confirmButton: "btn btn-danger",
              },
              buttonsStyling: false,
            })
          }
        })
  }

  const remove = async (id) => {
    await store.dispatch("cromis-institute/remove", id)
            .then((response) => {
              refetch()

              context.root.$swal({
                icon: "info",
                title: "System Info",
                text: "Institute has been deleted successfully",
                showConfirmButton: true,
                customClass: {
                  confirmButton: "btn btn-info",
                },
                buttonsStyling: true,
              })
            })
            .catch((error) => {
              context.root.$swal({
                icon: "error",
                title: "Server Error",
                text: "Something went wrong. See tech support",
                showConfirmButton: true,
                customClass: {
                  confirmButton: "btn btn-danger",
                },
                buttonsStyling: true,
              })
            })
  }

    return {
      dataForm,
      serverErrors,
      saving,

      institute,
      locations,
      administrativeLocations,
      levies,
      currencies,
      banks,
      branches,

      fetch,
      columns,
      perPage,
      currentPage,
      totalRecords,
      from,
      to,
      meta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      records,
      refetch,

      submit,
      remove,
      clear,
      invokeUpdateForm,
      changeBank,
      storeItem,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";
@import "~@core/scss/base/pages/app-email.scss";
</style>
